import type { FC } from 'react';
import { Badge } from '../../Badge/Badge';
import { Icon } from '../../Icon/Icon';
import { ListHeader } from '../ListHeader/ListHeader';
import { expandableListVariants } from './ExpandableList.styles';
import type { ExpandableListProp } from './ExpandableList.types';

export const ExpandableList: FC<ExpandableListProp> = ({
  size = 'default',
  label,
  className,
  opened = false,
  content,
  onToggle = () => {},
  startAdornmentIcon,
  badge,
}) => {
  const { base, header, headerLabel, arrow } = expandableListVariants();
  const renderArrow = () => {
    const icon = opened ? 'fa-angle-up' : 'fa-angle-down';
    return (
      <div className={arrow()}>
        <Icon glyph={icon} size='xs' />
      </div>
    );
  };

  return (
    <div className={base({ className })}>
      <div className={header()} onClick={onToggle}>
        <ListHeader
          label={label}
          size={size}
          startAdornmentIcon={startAdornmentIcon}
          className={headerLabel()}
        />
        {badge && <Badge color='neutral'>{badge}</Badge>}
        {renderArrow()}
      </div>
      {opened && content}
    </div>
  );
};
